import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'description', label: 'Description' },
  { key: 'asset_tag', label: 'Asset Tag' },
  { key: 'custodian', label: 'Custodian' },
  { key: 'purchase_value', label: 'Cost', align: 'right', type: 'money' },
  { key: 'useful_life_years', label: 'Useful Life (Yrs)', align: 'right' },
  { key: 'residual_value', label: 'Residual Value', align: 'right', type: 'money' },
  { key: 'depreciation_start_date', label: 'Depreciation Start' },
  { key: 'accumulated_depreciation', label: 'Accum. Depn', align: 'right', type: 'money' },
  { key: 'net_book_value', label: 'NBV', align: 'right', type: 'money' },
];

export function DepreciationScheduleReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Depreciation Schedule"
      description="Cost, accumulated depreciation and net book value for every fixed asset."
      endpoint="/reports/resources/depreciation-schedule"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'asset_category')}
    />
  );
}
